import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-title-section',
  templateUrl: './title-section.component.html',
  styleUrls: ['./title-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleSectionComponent {

  @Input() title: string;

}
